const Template = `<div>
<div  class="menu-tube">
	<b-form-input class='input-dark' v-model="filter" :placeholder="$t('general.search')"></b-form-input>
  
<div  class="menu-tube-table">

    <b-table
      id="left-table"
      :filter="filter"
      :items="tubes"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :tbody-tr-class="rowClass"
      striped
      borderless
      hover
      dark
    >
    <template v-slot:cell(action)="data">
        <b-button class="icons" v-on:click="showModal(data.item)"><img src="css/edit.svg"></b-button>
        </template>

        <template v-slot:cell(delete)="data">
        <b-button v-on:click="showDeleteModal(data.item)" class="icons"><img src="css/delete.svg"></b-button>
        </template>
    </b-table>

  </div>
      <b-pagination
      v-model="currentPage"
      :total-rows="menuRows"
      :per-page="perPage"
      aria-controls="left-table"
      first-text = "⏮"
      prev-text = "⏪"
      next-text = "⏩"
      last-text = "⏭"
    ></b-pagination>
  </div>

  <div class="edit-tube-modal">
  <b-modal size="lg"
  ref="EditModal" hide-footer
    header-bg-variant="dark"
    header-text-variant="light"
    :title="$t('addModem.editTubeData')">
    <b-row>
    <b-col>
      <b-form-group label-for="name-input">
        <b-col v-for="field in options" v-bind:key="field.id">
            <label>{{field.namelabel}}</label>
            <b-form-input
                v-model="field.info">
            </b-form-input>
        </b-col>
        <b-col>
            <label for="input-live">{{$t('addModem.modemCoords')}}</label>
            <b-form-input
            trim
            placeholder="27.68925, 53.94542"
            v-model="coords">
            </b-form-input>
        </b-col>
       
        <b-col>
        <label>{{$t('addModem.editContacts')}}</label>
        <b-form-checkbox-group 
          class="contacts"
          v-model="selected_phones"
          :options="phones"
          stacked>
        </b-form-checkbox-group>
        </b-col>

      </b-form-group>
      
    </b-col>

    <b-col>
    <div id="map" class="hidden"> </div>
     <b-col v-for="comment_type in comment_types" v-bind:key="comment_type.id">
            <label for="input-live">{{comment_type.namelabel}}</label>
            <b-form-textarea
                v-model="comment_type.info"
                :type="comment_type.typefield"
                :placeholder="$t('addModem.enterComment')"
            ></b-form-textarea>
        </b-col>
    </b-col>

    </b-row>
    <b-row> 
        <b-col><b-button class="" block variant="dark" @click="hideModal">{{$t('general.cancel')}}</b-button></b-col>
        <b-col></b-col>
        <b-col><b-button class="" block variant="success" @click="editModemTube()">{{$t('general.edit')}}</b-button></b-col>
    </b-row>
  </b-modal>
  </div>

  <b-modal header-bg-variant="dark"
    header-text-variant="light" 
    ref="messageModal" 
    hide-footer 
    title="Статус добавления элемента:">

      <div class="d-block text-center">
        <h4>{{message}}</h4>
      </div>
      <b-button class="mt-3" variant="outline-danger" block 
      v-on:click="hideMessage">Хорошо</b-button>
</b-modal>

<b-modal
ref="deleteModal" hide-footer
  header-bg-variant="dark"
  header-text-variant="light"
  title="Удаление участка трубы">
  
  <div>
        <h5>{{message}}</h5>
  </div>
    <b-button class="mt-3" block variant="success" @click="deleteTube()">Удалить элемент</b-button>
    <b-button class="mt-3" block variant="dark" @click="hideDeleteModal()">Отмена</b-button>
</b-modal>

</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/left_menu/template.js